export default function validateFile(fileType, acceptedTypes) {
    if (!acceptedTypes) return true;
    const allowedTypes = acceptedTypes.split(',');
    const mappedTypes = allowedTypes.map((el) => el.split('/')[0]);
    return mappedTypes.some((el) => fileType.startsWith(el));
}
